import {get, post} from '../interceptor'
let preUrl = '/myApi/honorInfo'

export default {
  getHonorInfo (params) { return post(preUrl, '/getHonorInfo', params) }
}



// WEBPACK FOOTER //
// ./src/api/company/honorManage.js